import React from 'react'
import { PASSWORD_HINT, PASSWORD_STRENGTH_COLORS, passwordStrength, passwordStrengthLabel } from '../utils/passwords'

export interface PasswordStrengthProps {
    password: string
    className?: string
}

const PasswordStrength = ({ password, className = '' }: PasswordStrengthProps) => {
    const strength = passwordStrength(password)

    return (
        <span className={`flex flex-col gap-1.5 ${className}`} aria-live="polite">
            <span className="mt-0.5 flex gap-1">
                {[0, 1, 2, 3].map((index) => (
                    <span
                        key={index}
                        className="h-1 flex-1 rounded-sm"
                        style={{ background: index < strength ? PASSWORD_STRENGTH_COLORS[strength - 1] : 'rgb(var(--k-line))' }}
                    />
                ))}
            </span>
            <span className="text-xs font-medium text-k-muted">
                {password ? passwordStrengthLabel(strength) : PASSWORD_HINT}
            </span>
        </span>
    )
}

export default PasswordStrength
